import Vue from 'vue'
import Vuex from 'vuex';
import news from './modules/news'
import register from './modules/register'
import login from './modules/login'
import logout from './modules/logout'
import models from './modules/models'
import cart from './modules/cart'
import locations from './modules/locations'
import language from './modules/language'
import main from "./modules/main";
import supports from "./modules/supports";
import pages from "./modules/pages";
import settings from "./modules/settings";
import cookies from "./modules/cookies";
import workWithUs from "./modules/work-with-us";
import addresses from "./modules/addresses";
import build from "./modules/build";
import baskets from "./modules/baskets";
import checkout from "./modules/checkout";
import bikes from "./modules/bikes";

Vue.use(Vuex);

Vue.filter('reverse', function (value) {
  return value.slice().reverse();
});

export default new Vuex.Store({
  modules: {
    main,
    news,
    supports,
    models,
    register,
    login,
    logout,
    cart,
    locations,
    language,
    pages,
    settings,
    cookies,
    workWithUs,
    addresses,
    build,
    baskets,
    checkout,
    bikes
  }
})
